//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getAllSelectedContent } from '@galleries/selectors/bulk-rights-selectors/getAllSelectedContent';

// If any selected items originated from syndication, don't allow these items to be syndicated
// further
export const getShouldDisableItemSyndication = createSelector(
  getAllSelectedContent,
  (allSelectedItems) => {
    const didAnyItemsComeFromSyndication = allSelectedItems.some(
      (item) => item.cameFromSyndication,
    );
    return didAnyItemsComeFromSyndication;
  },
);
